

import {sharableDashboardBuilderConfig} from './component';
import {sharableDashboardBuilderLoadingConfig} from './loading-component';
import {sharableDashboardBuilderPreviewConfig} from './preview-component';
import '../../services/hash-service';
import '../../services/state-service';
import '../../highcharts-modifiers';
import 'angular-drag-and-drop-lists';
import 'ng-file-upload';
import 'ngclipboard';

export default angular.module('sharable-dashboard.builder', [
    'ngRoute',
    'sharable-dashboard.hash-service',
    'sharable-dashboard.state-service',
    'dndLists',
    'ngFileUpload',
    'ui.tinymce',
    'ngclipboard',
    'MW.Framework.CoreCompanyService',
])
.config(['$routeProvider', function ($routeProvider) {
    'use strict';

    $routeProvider.when('/sharable-dashboard-builder/:dashboardId?/:generateContent?', {
        template: function(params) {
            return '<mw-pr-insight-sharable-dashboard-report-builder ' +
                        'dashboard-id="' + params.dashboardId + '"  ' +
                        'generate-content="' + (params.generateContent !== undefined ? params.generateContent : true) + '" ' +
                        'shared-reports-count="$resolve.sharedReportsCount">' +
                    '</mw-pr-insight-sharable-dashboard-report-builder>'

        },
        activeTab: 'builder',
        resolve: {
            sharedReportsCount: function getSharedReportsCount(CoreCompanyService, $http) {
                return CoreCompanyService.getCurrent(true).then(function (company) {
                    return $http.get('/aws/dynamoDb/sharableDashboards/' + company._id).then(function (sharedDashboards) {
                        return sharedDashboards.data.length || 0;
                    });
                });
            }
        },
        title: 'Share Dashboard',
        reloadOnSearch: false
    });

}])
.component(sharableDashboardBuilderLoadingConfig.name, sharableDashboardBuilderLoadingConfig)
.component(sharableDashboardBuilderPreviewConfig.name, sharableDashboardBuilderPreviewConfig)
.component(sharableDashboardBuilderConfig.name, sharableDashboardBuilderConfig);